import type { Invoice, InvoiceStatus, InvoiceType } from '@/modules/billing/types';

export type InvoiceListFilters = {
  status?: InvoiceStatus | 'all';
  type?: InvoiceType | 'all';
  search?: string;
  commercialOperationId?: string;
};

export function filterInvoices(
  invoices: Invoice[],
  filters: InvoiceListFilters,
): Invoice[] {
  let result = [...invoices];
  const search = filters.search?.trim().toLowerCase();

  if (filters.status && filters.status !== 'all') {
    result = result.filter((i) => i.status === filters.status);
  }
  if (filters.type && filters.type !== 'all') {
    result = result.filter((i) => i.type === filters.type);
  }
  if (filters.commercialOperationId) {
    result = result.filter(
      (i) => i.commercialOperationId === filters.commercialOperationId,
    );
  }
  if (search) {
    result = result.filter(
      (i) =>
        i.invoiceNumber.toLowerCase().includes(search) ||
        i.notes.toLowerCase().includes(search),
    );
  }

  return result.sort((a, b) => b.updatedAt.getTime() - a.updatedAt.getTime());
}
